import React from 'react';
import Paper from 'material-ui/Paper';
import {List, ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import Circle from 'material-ui/svg-icons/av/fiber-manual-record';
import MyAccount from 'material-ui/svg-icons/social/person';
import { cdnPath } from '../../constants/config';

class Messages extends React.Component {

    selectMessage = (message) => {
        message.NewMessage = false;
        message.NewMessages = 0;
        this.props.selectMessage(message);
        //this.props.router.push(`/message/${message.SystemMessageID}/view`);
    };

    renderItem = (message) => {

        if(message.Attachment) {
            return this.renderAttachment(message.Attachment);
        }
        else{
            return <div style={{width:'90%'}}  dangerouslySetInnerHTML={{__html: message.Message}} />
        }

    }

    renderCgAvatar = (cg) => {
        if(cg.AvatarUrl){
            
            return <img  style={{top:20, height:50, width:50,  borderRadius: '50%'}} src={cg.AvatarUrl} /> 
            //<Avatar size={44} style={{top:20,  borderRadius: '50%'}} src={require(`https://${cdnPath}/careguides/avatars/cg-1.png`)}> </Avatar>
        }
        else{
            return <Avatar size={44} style={{top:20}}> <div className="care-guide-small" /> </Avatar>
        }
    }

    renderAttachment = (a) => {
        return <div>{a.Name}</div>
        // switch(a.AttachmentTypeID) {
        //     case 1:
        //     case 2:
        //     case 3:
        //     case 4:
        //         return <div>{a.Name}</div>
        // }
    }

    renderSubject = (message) => {
        if(message.Subject) {
            return <div style={{padding: '0px 27px 0px 0px'}} >{message.Subject}</div>
        }
        else{
            return ""
        }
    }
    

    render() {

        var self = this;
        var dasmessages = this.props.messages.map((message, index) => 

            <div key={index} id={"message_" + message.SystemMessageID} >
            {/* rightIconButton={rightIconMenu(message.SystemMessageID)} */}
            <ListItem value={index}
                leftAvatar={

                    (message.CareGuide 
                        ? this.renderCgAvatar(message.CareGuide)
                        : <Avatar size={44}  icon={<MyAccount />} style={{backgroundColor:"#999999", top:20}} /> 
                    ) 
                } 
                rightIcon={ 
                    <div style={{width:70, textAlign:'center'}}>
                    {(message.NewMessage || message.NewMessages > 0 ? <Circle color="#00BCD4" style={{height:20}} /> : "")}
                    <br />
                    {<span style={{fontSize:14}}>{message.DateSent}</span>}
                    </div>
                }
                primaryText={this.renderSubject(message)}
                    
                secondaryText={this.renderItem(message)}
                onClick={() => this.selectMessage(message)}
                secondaryTextLines={2}
            />
            {((index + 1) !== this.props.messages.length) && (
                <Divider />
            )}
        
        </div>
    );

    return (
        <div>
            <Paper>
                {(this.props.messages.length === 0) && (
                    <div className="container trueno centered">
                    <h5>No Messages</h5>
                    </div>
                )}
                {(this.props.messages.length > 0) && (
                    <div>
                        { dasmessages }
                    </div>
                )}
            </Paper>
            <br />
            <br />
            <br />
            <br />
        </div>
    );
  }
};

export default Messages;





// WEBPACK FOOTER //
// ./src/Components/Messaging/List.js